import React, { Component } from 'react';
import { withContext } from '../utils/StateProvider';
import classNames from 'classnames';
import ButtonFace from './buttonFace';
import { playSound, primeAudio } from '../utils/audio';

class ActionButton extends Component {
  
  render() {
    return (
        <div className={classNames(this.props.classes, { 'has-icon': this.props.icon })} onClick={()=>{ primeAudio(); playSound('click'); this.props.actionClick(this.props.alt); }}>
          <ButtonFace icon={this.props.icon} turn={this.props.turn} label={this.props.alt} />
        </div>
    );
  }
}

export default withContext(ActionButton);